import { ComponentType, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck, Zap, Mail } from 'lucide-react';
import { cn } from '@/lib/utils';

/*
 * ReassuranceRow — DESIGN_SYSTEM.md §2.6
 *
 * Three inline icon+label items used at the foot of the BookingSummaryCard,
 * marketing hero, and confirmation surfaces. Defaults to Secure / Instant /
 * Email confirm; consumer can override `items`.
 */

export interface ReassuranceItem {
  icon: ComponentType<{ className?: string }>;
  label: ReactNode;
}

interface ReassuranceRowProps {
  items?: ReassuranceItem[];
  className?: string;
}

export function ReassuranceRow({ items, className }: ReassuranceRowProps) {
  const { t } = useTranslation('publicBooking');
  const defaults: ReassuranceItem[] = [
    { icon: ShieldCheck, label: t('reassurance.secure') },
    { icon: Zap,         label: t('reassurance.instant') },
    { icon: Mail,        label: t('reassurance.emailConfirm') },
  ];
  const resolvedItems = items ?? defaults;
  return (
    <div className={cn('flex items-center justify-center gap-4 text-body-xs text-soft', className)}>
      {resolvedItems.map((item, i) => {
        const Icon = item.icon;
        return (
          <span key={i} className="inline-flex items-center gap-1">
            <Icon className="h-3.5 w-3.5" aria-hidden />
            {item.label}
          </span>
        );
      })}
    </div>
  );
}
